class Can {
    show(rol) {
        let md5 = require('md5');
        let sha1 = require('sha1');
        let auth = sha1(md5("ADMIN")); 
        if (rol === auth)
            return true;
    }
}
export default Can;


// WEBPACK FOOTER //
// ./src/config/Can.js